import React from 'react';
import { motion } from 'framer-motion';
import RupeeSymbol from '../RupeeSymbol';
import './FAQ.css';

const FAQ = () => {
  const faqs = [
    {
      question: "How do I use the DEMO35 code?",
      answer: "Click any upgrade button above. You'll be taken to checkout where you can enter code DEMO35 to get 35% off your Elite plan. For quarterly plans, the free eCourse is automatically added."
    },
    {
      question: "How long is my DEMO35 code valid?",
      answer: "Your DEMO35 code expires with the countdown timer at the top of this page. Once it reaches zero, the 35% discount and free eCourse bonus are no longer available. This is your only opportunity to lock this rate."
    },
    {
      question: "What's included in the free eCourse?",
      answer: (
        <>
          The eCourse (<RupeeSymbol />5,899 value) is a comprehensive program covering professional NSE trading strategies, order flow analysis techniques, market profile interpretation, and risk management. It's designed to help you master Elite's tools and trade more profitably.
        </>
      )
    },
    {
      question: "Can I upgrade from monthly to annual later?",
      answer: "Yes, but you won't get the DEMO35 discount again. This 35% off rate + free eCourse bonus is exclusive to your demo period. If you upgrade later, you'll pay standard rates."
    },
    {
      question: "Is this a recurring payment?",
      answer: "No. Currently we do not auto-debit your account. You will have to manually re-purchase a fresh plan whenever your current plan expires."
    },
    {
      question: "What happens to my demo workspace settings?",
      answer: "When you upgrade immediately, all your demo workspace settings, saved charts, and configurations transfer seamlessly. Zero disruption, zero setup time. Just continue trading right where you left off."
    }
  ];

  return (
    <section className="faq-section">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          ❓ Frequently Asked Questions
        </motion.h2>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="faq-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="faq-question">{faq.question}</div>
              <div className="faq-answer">{faq.answer}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

